import { Reveal } from "@/lib/reveal";
import { TrendingUp, Target, ShieldCheck } from "lucide-react";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <span className="text-xs font-bold tracking-[0.22em] uppercase text-[#FF7B00]">
              — About the studio
            </span>
          </Reveal>

          <Reveal delay={100}>
            <h2 className="font-display mt-5 text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight">
              Built for brands that{" "}
              <span className="text-gradient-gold">refuse to stay small.</span>
            </h2>
          </Reveal>

          <Reveal delay={200}>
            <p className="mt-6 text-lg text-zinc-400 leading-relaxed max-w-2xl">
              Mature Marketing &amp; Services is a performance-first studio
              helping ambitious businesses outgrow their category. We combine
              sharp brand strategy, relentless ad optimisation, and conversion
              design — engineered around one thing: reliable, compounding
              growth.
            </p>
          </Reveal>

          <Reveal delay={280}>
            <div className="mt-10 grid sm:grid-cols-3 gap-6">
              {[
                {
                  icon: TrendingUp,
                  title: "Growth Engineered",
                  desc: "Funnels built for compounding revenue, not vanity metrics.",
                },
                {
                  icon: Target,
                  title: "Performance First",
                  desc: "Every creative, every spend — tied to a measurable outcome.",
                },
                {
                  icon: ShieldCheck,
                  title: "Reliability",
                  desc: "A partner you can call on — predictable, consistent delivery.",
                },
              ].map((i) => (
                <div
                  key={i.title}
                  data-testid={`about-pillar-${i.title.toLowerCase().replace(/\s/g, "-")}`}
                  className="rounded-2xl border border-white/5 bg-[#0F0F0F] p-6 hover:border-[#FF7B00]/30 transition-colors"
                >
                  <i.icon
                    className="h-7 w-7 text-[#FF7B00]"
                    strokeWidth={1.5}
                  />
                  <div className="font-display mt-4 text-lg font-bold">
                    {i.title}
                  </div>
                  <p className="text-sm text-zinc-500 leading-relaxed mt-2">
                    {i.desc}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={180}>
            <div className="relative rounded-3xl overflow-hidden border border-white/10 group">
              <img
                src="https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbHV4dXJ5JTIwYWJzdHJhY3QlMjBnb2xkfGVufDB8fHx8MTc3NjYwNjk5NXww&ixlib=rb-4.1.0&q=85"
                alt="Abstract golden metallic lines on black background"
                className="h-[520px] w-full object-cover transition-transform duration-[1.6s] group-hover:scale-[1.04]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
              <div className="absolute left-6 right-6 bottom-6">
                <div className="flex items-end justify-between">
                  <div>
                    <div className="text-xs uppercase tracking-[0.22em] text-[#FFB347]">
                      Est. 2019
                    </div>
                    <div className="font-display text-2xl font-bold mt-1">
                      Strategy · Craft · Scale
                    </div>
                  </div>
                  <div className="h-12 w-12 rounded-full border border-[#FF7B00]/40 flex items-center justify-center text-[#FF7B00]">
                    ✦
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
